export default {
  // Login form
  login: 'Login',
  email: 'Email',
  password: 'Password',
  showPassword: 'Show password',
  hidePassword: 'Hide password',
  forgotPassword: 'Forgot your password?',
  enter: 'Enter',
  or: 'or',

  // SSO
  signInWithMicrosoft: 'Sign in with Microsoft',
  signInWithGoogle: 'Sign in with Google',
  continueWithMicrosoft: 'Continue',

  // Recover password modal
  enterEmailToFindAccount: 'Enter your email address to find your account.',
  send: 'Send',
  checkYourEmail: 'Check your email.',

  // SSO Institution modal
  microsoftSignIn: 'Sign in',
  institutionDetectedAutomatically: 'Institution detected automatically',
  selectInstitution: 'Select an institution',
  pleaseSelectInstitution: 'Please select an institution',

  // SSO loading/errors
  redirectingToMicrosoft: 'Redirecting to Microsoft...',
  pleaseWait: 'Please wait',
  errorSigningIn: 'Error signing in',
  errorSigningInWithMicrosoft: 'An error occurred while signing in with Microsoft',
  errorDuringMicrosoftAuthentication: 'An error occurred during Microsoft authentication',
  ssoErrorHint: "If you believe this is a mistake, contact your institution's administrator.",
  noSSOInstitutionsAvailable: 'No SSO institutions available',
  useTraditionalSignIn: 'Please use traditional sign in.',

  // SSO auto-login confirmation modal
  microsoftSSOAvailable: 'Microsoft sign-in available',
  microsoftSSOConfirmText: '{institution} uses Microsoft for authentication. Do you want to sign in with Microsoft?',
  microsoftSSOConfirm: 'Yes, use Microsoft',
  microsoftSSODecline: 'No, use credentials',

  // Institution redirect (klearning.cl main domain)
  selectYourInstitution: 'Select your institution',
}
